import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/Modal'
import { showErrorToast } from 'utils/toast'
import { cancelReassessmentRequest } from 'api/siteSpecie'
import { SiteContext } from 'providers/site'
import { FormattedMessage } from 'react-intl'
import WarnFlowRequestModal from 'components/FlowRequestModal/WarnFlow'

const WarningModal = ({ isOpen, setIsOpen, closeEditSpeciesModal, site, item, toggleModal }) => {
  const { getSiteValidation } = useContext(SiteContext)
  const confirmAction = () => {
    cancelReassessmentRequest({ siteId: site.historyId, specieId: item.historyId, isCancelled: true }).then((data) => {
      if (data.error) {
        return showErrorToast(data.error)
      }
      // Refetch rather than reset so validation errors on other species stay visible
      getSiteValidation?.()
      setIsOpen(false)
      closeEditSpeciesModal()
      toggleModal?.()
    })
  }

  return (
    <Modal width='416px' isOpen={isOpen} toggleModal={() => {
      toggleModal?.()
      return setIsOpen(!isOpen)
    }} modalTitleId='warningModalHeader'>
      <WarnFlowRequestModal
        cancelHandler={() => {
          toggleModal?.()
          return setIsOpen(false)
        }}
        confirmHandler={confirmAction}
        confirmBtnText='yesCancel'
        rejectBtnText='continueEditing'
        text={<FormattedMessage id='warningModalExplanation' />}
        item={item}
        approve={true}
      />
    </Modal>
  )
}

WarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  closeEditSpeciesModal: PropTypes.func.isRequired,
  site: PropTypes.shape({
    historyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  item: PropTypes.shape({
    historyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired,
  toggleModal: PropTypes.func
}

export default WarningModal
